<template>
  <div>
    <div id="div-integration">
      <span class="title">{{ $t('menu.settings.integrations.name') }}</span>
      <table class="col-12">
        <tr>
          <td class="column-title">
            {{ $t('menu.settings.integrations.status') }}
          </td>
          <td class="column-title">
            {{ $t('menu.settings.integrations.integration') }}
          </td>
          <td class="column-title">
            {{ $t('menu.settings.integrations.description') }}
          </td>
        </tr>
        <tr>
          <td class="line-column">
            <template v-if="zenviaStatus">
              <span id="enabled"></span>
              <span>{{ $t('menu.settings.integrations.enabled') }}</span>
            </template>
            <template v-if="!zenviaStatus"
              ><span id="disabled"></span
              ><span>{{
                this.$t('menu.settings.integrations.disabled')
              }}</span></template
            >
          </td>
          <td class="line-column line-column-title">
            <a
              class="line-column-title"
              @click="routerPath('/integrations/zeenvia')"
              >Zenvia</a
            >
          </td>
          <td class="line-column description">
            {{ $t('menu.settings.integrations.descriptionZeenvia') }}
          </td>
          <td class="line-column">
            <a @click="routerPath('/integrations/zeenvia')"
              ><i class="fas fa-pen pen"></i
            ></a>
          </td>
        </tr>
        <tr>
          <td class="line-column">
            <!-- <span id="enabled"></span>
            <span>{{ $t('menu.settings.integrations.enabled') }}</span> -->
            <span id="enabled"></span>
            <span>{{ this.$t('menu.settings.integrations.enabled') }}</span>
          </td>
          <td class="line-column line-column-title">
            <a
              class="line-column-title"
              @click="routerPath('/integrations/api-key')"
              >API</a
            >
          </td>
          <td class="line-column description">
            {{ $t('menu.settings.integrations.descriptionApiKey') }}
          </td>
          <td class="line-column">
            <a @click="routerPath('/integrations/api-key')"
              ><i class="fas fa-pen pen"></i
            ></a>
          </td>
        </tr>
      </table>
    </div>
    <div id="div-webhooks">
      <span class="title">Webhooks</span>
      <table class="col-12">
        <tr>
          <td class="column-title">
            {{ $t('menu.settings.integrations.status') }}
          </td>
          <td class="column-title">
            {{ $t('menu.settings.integrations.event') }}
          </td>
          <td class="column-title">
            {{ $t('menu.settings.integrations.description') }}
          </td>
        </tr>
        <tr>
          <td class="line-column">
            <template v-if="active">
              <span id="enabled"></span>
              <span>{{ $t('menu.settings.integrations.enabled') }}</span>
            </template>
            <template v-if="!active"
              ><span id="disabled"></span>
              <span>{{
                this.$t('menu.settings.integrations.disabled')
              }}</span></template
            >
          </td>
          <td class="line-column line-column-title">
            <a
              class="line-column-title"
              @click="routerPath('/integrations/collect-response')"
              >{{ $t('menu.settings.integrations.collectionAnswers') }}</a
            >
          </td>
          <td class="line-column description">
            {{ $t('menu.settings.integrations.collectDescription') }}
          </td>
          <td class="line-column">
            <a @click="routerPath('/integrations/collect-response')"
              ><i class="fas fa-pen pen"></i
            ></a>
          </td>
        </tr>

        <!-- <tr>
          <td class="line-column">
            <template v-if="active">
              <span id="enabled"></span>
              <span>{{ $t('menu.settings.integrations.enabled') }}</span>
            </template>
            <template v-if="!active"
              ><span id="disabled"></span>
              <span>{{
                this.$t('menu.settings.integrations.disabled')
              }}</span></template
            >
          </td>
          <td class="line-column line-column-title">
            <a
              class="line-column-title"
              @click="routerPath('/integrations/collect-shoot')"
              >Coleta de disparo</a
            >
          </td>
          <td class="line-column description">
            Cadastre um end-point para recebimento em tempo dos disparos coletados pelo Indecx.
          </td>
          <td class="line-column">
            <a @click="routerPath('/integrations/collect-shoot')"
              ><i class="fas fa-pen pen"></i
            ></a>
          </td>
        </tr> -->

        <tr>
          <td class="line-column">
            <!-- <span id="enabled"></span>
            <span>{{ $t('menu.settings.integrations.enabled') }}</span> -->
            <span id="disabled"></span>
            <span>{{ this.$t('menu.settings.integrations.disabled') }}</span>
          </td>
          <td class="line-column line-column-title">
            Close the looping
          </td>
          <td class="line-column description">
            {{ $t('menu.settings.integrations.loopDescription') }}
          </td>
          <td class="line-column">
            <i @click="messageDev" class="fas fa-pen pen"></i>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import swal from 'sweetalert';
import api from '../../../../services/api';

export default {
  name: 'Integrations',

  data() {
    return {
      userAuth: null,
      active: false,
      zenviaStatus: false,
      getStatusZenvia: {},
    };
  },

  methods: {
    ...mapActions('zenvia', ['getZenviaConfig']),

    routerPath(path) {
      this.$router.push(path);
    },

    messageDev() {
      swal({
        title: 'Em breve',
        text: 'Em desenvolvimento...',
        icon: 'success',
        buttons: 'Ok',
      });
    },
  },

  async mounted() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    const response = await api.get(`/webhooks/${this.userAuth.companyId}`, {
      headers: { 'x-access-token': this.userAuth.token },
      params: {
        companyId: this.userAuth.companyId,
      },
    });

    this.active = response.data ? response.data.events[0].active : false;

    this.getStatusZenvia = await this.getZenviaConfig({
      token: this.userAuth.token,
      companyId: this.userAuth.companyId,
    });
    this.zenviaStatus = this.getStatusZenvia.enabled;
  },

  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
  },
};
</script>

<style scoped>
#enabled {
  border-radius: 50%;
  display: inline-block;
  height: 20px;
  width: 20px;
  background-color: #28a745;
  margin-bottom: -5px;
}

#disabled {
  border-radius: 50%;
  display: inline-block;
  height: 20px;
  width: 20px;
  background-color: #eb5555;
  margin-bottom: -5px;
}

#div-integration {
  background-color: #fcfcfc;
  padding: 15px;
}

#div-webhooks {
  background-color: #fcfcfc;
  padding: 15px;
  margin-top: 25px;
}

td {
  padding: 15px;
  border-width: medium;
  border-style: solid;
  border-color: #fcfcfc;
}

.title {
  font-weight: bold;
  font-size: 20px;
}

.column-title {
  text-transform: uppercase;
  font-size: 15px;
  font-weight: 700;
  color: #919191;
  padding-bottom: 15px;
}

.pen {
  color: #919191;
  width: 10px;
}

.line-column {
  background-color: white;
  color: #919191;
  border-left: none;
  border-right: none;
  cursor: pointer;
}

.line-column-title {
  color: #72bcd4;
  font-weight: 700;
}

.description {
  color: #919191;
  width: 70%;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/settings/integrations-webhooks/index.vue